import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core/styles';
import * as Color from 'color';
import config from '../config';

export function LineSegment(props) {
  const {
    lineType, start, end, onDateSelected, fade, theme, yearWidth,
  } = props;

  const width = end.diff(start, 'days') / 365 * yearWidth;
  const color = theme.lifeline.palette[lineType];
  const startColor = Color(color).fade(fade[0] ? fade[0] : 0);
  const endColor = Color(color).fade(fade[1] ? fade[1] : 0);

  return (
    <div
      onClick={(event) => {
        const daysFromStart = event.nativeEvent.offsetX / yearWidth * 365;
        onDateSelected(start.clone().add(daysFromStart, 'days'));
      }}
      style={{
        zIndex: 250,
        background: `linear-gradient(to right, ${startColor}, ${endColor})`,
        width: `${width}px`,
        height: `${config.LINE_HEIGHT}px`,
      }}
    />
  );
}

LineSegment.propTypes = {
  yearWidth: PropTypes.number.isRequired,
  lineType: PropTypes.oneOf(['wild', 'captive', 'logbook']).isRequired,
  start: PropTypes.shape().isRequired,
  end: PropTypes.shape().isRequired,
  theme: PropTypes.shape().isRequired,
  onDateSelected: PropTypes.func,
  fade: PropTypes.arrayOf(PropTypes.number),
};
LineSegment.defaultProps = {
  onDateSelected: () => {},
  fade: [null, null],
};

export default withTheme()(LineSegment);



// WEBPACK FOOTER //
// ./src/components/lifeline/Line/LineSegment.jsx